// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/components/recentEvaluations/recentEvaluations.scss
// module id = 157
// module chunks = 0